<form (ngSubmit)="getTokenBtn()" class="login-modal">

  <img class="pointer login-modal__close" width="24" height="24" [alt]="'LOGIN_MODAL.CLOSE' | translate" (click)="cancel()" src="assets/img/close_black.svg">

  <div class="login-modal__logo">
    <img src="{{ eventData['imageLogo'] }}" class="top-logo-img" *ngIf="eventData['imageLogo']">
    <img ng-src="/assets/empty.png" class="top-logo-img" *ngIf="!eventData['imageLogo']">
  </div>

  <div class="login-modal__title">
    <h3 id="modal-title">{{ 'LOGIN_MODAL.TITLE' | translate }}</h3>
    <p>{{ 'LOGIN_MODAL.DESCRIPTION' | translate }}</p>
  </div>

  <div class="form-group form-group--username">
    <label for="username">{{ 'LOGIN_MODAL.USERNAME' | translate }}</label>
    <input type="email" class="form-control" id="username" name="username" required [(ngModel)]="user['username']">
  </div>

  <div class="form-group form-group--password">
    <label for="password">{{ 'LOGIN_MODAL.PASSWORD' | translate }}</label>
    <input [type]="typePassword" class="form-control" id="password" name="password" required [(ngModel)]="user['password']">
    <img class="pointer login-modal__show-password" width="24" height="24" [alt]="'LOGIN_MODAL.CLOSE' | translate"
    (click)="togglePassword()" src="assets/img/remove_red_eye.svg">
    <a class="login-modal__password-recovery pointer" (click)="passwordRecovery()">{{ 'LOGIN_MODAL.PASSWORD_RECOVERY' | translate }}</a>
  </div>


  <button class="btn btn--submit white" [style.background-color]="eventData['mainColor']" [style.color]="eventData['languageColor']" type="submit">{{ 'LOGIN_MODAL.LOGIN' | translate }}</button>

  <button [title]="'LOGIN_MODAL.ONE_TIME_PASSWORD_TITLE' | translate" [style.background-color]="eventData['mainColor']" [style.color]="eventData['languageColor']" class="btn btn--submit btn--otp appColorBackground white" type="button" (click)="sendOneTimePasswordBtn()" [disabled]="!user['username']">{{ 'LOGIN_MODAL.ONE_TIME_PASSWORD' | translate }}</button>

  <div class="errorMessage" *ngIf="alertMessage">
    {{ alertMessage | translate }}
  </div>

  <div class="okMessage" *ngIf="okMessage">
    {{ okMessage | translate }}
  </div>


</form>
